module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict02_01-131db9cbbc6d56a4ba13bbb1cd4d9402.webp";